import { createLucideIcon } from 'lucide-react'

export const Npm = createLucideIcon('Npm', [
  [
    'path',
    {
      d: 'M2 22V2H22V22H2Z',
      key: '1',
      fill: '#C12127',
      strokeWidth: '0',
    },
  ],
  [
    'path',
    {
      d: 'M5.75 5.75H18.25V18.25H15.75V8.25H12V18.25H5.75V5.75Z',
      key: '2',
      fill: '#fafafa',
      strokeWidth: '0',
    },
  ],
])

export const NpmWordmark = createLucideIcon('NpmWordmark', [
  [
    'path',
    {
      d: 'M8.15385 15.4103H10.7179V14.1282H13.2821V9H8.15385V15.4103ZM10.7179 10.2821H12V12.8462H10.7179V10.2821ZM14.3077 9V14.1282H16.8718V10.2821H18.1538V14.1282H19.4359V10.2821H20.7179V14.1282H22V9H14.3077ZM2 14.1282H4.5641V10.2821H5.84615V14.1282H7.12821V9H2V14.1282Z',
      key: '1',
      fill: 'currentColor',
      strokeWidth: '0',
    },
  ],
])
